import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr } from '../../../../helpers/custom-prop-types';
const ProffitSearchLandingPageCtaSubText = (props) => {
    const { className } = props;
    return (_jsx("div", Object.assign({ className: clsx('proffit_search_landing_page_cta_sub_text', className) }, { children: _jsx("span", Object.assign({ className: 'text_value' }, { children: "1\u5206\u3067\u767B\u9332\u5B8C\u4E86\uFF01" })) })));
};
ProffitSearchLandingPageCtaSubText.propTypes = {
    className: propStr(),
};
ProffitSearchLandingPageCtaSubText.defaultProps = {
    className: '',
};
export default ProffitSearchLandingPageCtaSubText;
